import { Outlet } from "react-router-dom";
import { CrisisBar } from "@/components/CrisisBar";
import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";
import { t } from "@/lib/i18n";

export const PublicLayout = () => (
  <div className="min-h-screen flex flex-col bg-cream-50 text-ink-900">
    <a href="#main" className="sr-only-focusable fixed left-4 top-4 z-50 rounded bg-olive-900 px-4 py-3 text-cream-50">{t("nav.skip")}</a>
    <CrisisBar />
    <PublicHeader />
    <main id="main" className="flex-1" tabIndex={-1}>
      <Outlet />
    </main>
    <PublicFooter />
  </div>
);

export const Page = ({ title, lede, children, testId }) => (
  <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6 sm:py-16" data-testid={testId}>
    <header className="max-w-3xl">
      <h1 className="text-4xl sm:text-5xl lg:text-6xl">{title}</h1>
      {lede && <p className="mt-5 text-base md:text-lg text-ink-500 max-w-[65ch]">{lede}</p>}
    </header>
    <div className="mt-10 sm:mt-14">{children}</div>
  </div>
);
